/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#debouncethenexecute
 */
var feeJS = feeJS || {};
feeJS.debounceThenExecute = (func, delay) => {
  let timerId;

  return function () {
    const context = this;
    const args = arguments;

    clearTimeout(timerId);

    timerId = setTimeout(function () {
      func.apply(context, args);
    }, delay);
  };
}



/**
 * documentation at
 * https://webartelier.de/fee_doc/list_functions.html#executethendebounce
 */

feeJS.executeThenDebounce = (func, delay) => {
  let timerId;

  return function () {
    const context = this;
    const args = arguments;

    if (timerId) {
      clearTimeout(timerId);
      return
    }

    func.apply(context, args);

    timerId = setTimeout(function () {
      timerId = null;
    }, delay);
  };
}